import { render, staticRenderFns } from "./InfoMySale.vue?vue&type=template&id=10478fee&scoped=true"
import script from "./InfoMySale.vue?vue&type=script&lang=js"
export * from "./InfoMySale.vue?vue&type=script&lang=js"
import style0 from "./InfoMySale.vue?vue&type=style&index=0&id=10478fee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10478fee",
  null
  
)

export default component.exports